export var GraphData = {
	methods: {},
	computed: {
		graphData: function() {
			return {
				title: {
					text: this.getNameOfGraph ? this.getNameOfGraph : "",
					show: true,
					left: "center",
					top: "top",
					padding: [0, 0, 10, 0],
					textStyle: {
						color: "#484848"
					}
				},
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: "shadow"
					}
				},
				legend: this.graphLegend,
				grid: {
					top: "30%", // graph top spacing
					bottom: "20%" // graph bottom spacing
				}, 
				yAxis: this.graphYaxis,
				xAxis: this.graphXaxis,
				color: this.graphColors,
				series: this.graphSeries
			};
		}
	},
	data() {
		return {
			graphLegend: {
				
			},
			graphColors: ["#e29d5a", "#f9cb9c", "#fce5cd"],
			// graphColors: ['#1E95CE', '#D55672', '#483D3F','#717EC3', '#80CED7', '#ca8622', '#bda29a','#6e7074', '#546570', '#c4ccd3'],
			graphSeries: [
				 {
					 
				 }
			],
			graphYaxis: {
				type: "-",
				data: [],
				scale: true,
				min: 0,
				max: "",
				axisLabel: {
					margin: 20,
					rotate: 15,
				},
				axisLine: {
					lineStyle: {
						color: '#dc143c'
					}
				}
				},
			graphXaxis: {
				type: "category",
				// boundaryGap: false,
				data: [],
				scale: true,
				min: 0,
				max: "",
				axisLabel: {
					margin: 20,
					rotate: 15,
					formatter: function (value, index) {
						// return (value.split(' ')).join('\n');
						// return (value.length > 6 ? (value.slice(0,6)+"...") : value);
						var label = (value.length > 8 ? (value.slice(0,8)+"...") : value);
						return label.charAt(0).toUpperCase() + label.slice(1);
					},
				},
			},
			initOptions: { renderer: "svg" },
			loading: true
		};
	}
};
